import React, { useEffect, useRef } from 'react';

const TicketActionDialog = ({ title, busy, onClose, children }) => {
  const dialogRef = useRef(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    dialog.showModal();
    return () => dialog.close();
  }, []);

  return <dialog ref={dialogRef} className="ticket-action-dialog" aria-label={title}
    onCancel={event => { event.preventDefault(); if (!busy) onClose(); }}
    onClick={event => { if (event.target === event.currentTarget && !busy) onClose(); }}>
    {children}
  </dialog>;
};

export default TicketActionDialog;
